var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 3.11111C1 2.55121 1.20018 2.01424 1.5565 1.61833C1.91282 1.22242 2.39609 1 2.9 1H18.1C18.6039 1 19.0872 1.22242 19.4435 1.61833C19.7998 2.01424 20 2.55121 20 3.11111V13.6667C20 14.2266 19.7998 14.7635 19.4435 15.1595C19.0872 15.5554 18.6039 15.7778 18.1 15.7778H2.9C2.39609 15.7778 1.91282 15.5554 1.5565 15.1595C1.20018 14.7635 1 14.2266 1 13.6667V3.11111Z",
    stroke: "#0E0E0E",
    strokeWidth: 1.75358,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.70013 20.0001H14.3001M10.5001 15.7778V20.0001",
    stroke: "#0E0E0E",
    strokeWidth: 1.75358,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.386f2249682d0a4dfbcc4bad0f52cb9b.svg";
export { ForwardRef as ReactComponent };